import { cn } from "@/lib/utils";

const PingColors = {
  default: "bg-sky-400",
  success: "bg-green-400",
  warning: "bg-yellow-400",
  destructive: "bg-red-400",
};

type Props = {
  variant?: "success" | "destructive" | "warning" | "default";
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};

export const Ping = ({ variant = "default", className }: Props) => {
  const bgColor = PingColors[variant];

  return (
    <div className={className}>
      <span className="relative flex h-3 w-3">
        <span
          className={cn(
            "animate-ping absolute inline-flex h-full w-full rounded-full opacity-75",
            bgColor,
          )}
        />
        <span
          className={cn("relative inline-flex rounded-full h-3 w-3", bgColor)}
        />
      </span>
    </div>
  );
};
